import React from 'react';

import { CarsStockMobileProps } from './types';
import Title from './components/Title';
import Tabs from './components/Tabs';
import Filters from './components/Filters';
import SelectedFilters from './components/SelectedFilters';
import CarsListHeader from './components/CarsListHeader';
import CarsList from './components/CarsList';
import CompareButton from './components/CompareButton';
import Pagination from './components/Pagination';

function CarsStockMobile({ carsType }: CarsStockMobileProps) {
  return (
    <React.Fragment>
      <Title carsType={carsType} />
      <Tabs carsType={carsType} />
      <Filters carsType={carsType} />
      <SelectedFilters />
      <CarsListHeader carsType={carsType} />
      <CarsList carsType={carsType} />
      <CompareButton />
      <Pagination />
    </React.Fragment>
  );
}

export default CarsStockMobile;
